exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/traffic/traffic.scss
 ** module id = 68
 ** module chunks = 0
 **/